import React, { forwardRef } from "react";

import { DropdownMenuSeparator } from "src/primitives/DropdownMenu";

const Divider = forwardRef<
  HTMLDivElement,
  React.ComponentProps<typeof DropdownMenuSeparator>
>((props, ref) => <DropdownMenuSeparator ref={ref} {...props} />);
Divider.displayName = "Dropdown.Divider";

export { Divider };
